module.exports = __webpack_public_path__ + "img/IMG-20191123-WA0038.4f840e50.jpg";